/***
 * @file portal的管理统一收敛到这里，如果存在多个portal，方便在底层做一些控制
 */

import { Component, ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { $document } from '@umu/umu-dom';

export interface IProps {
    children?: ReactNode;
    node?: Element | null;
    preventBodyScroll?: boolean;
}

const PREVENT_SCROLL_CLASS_NAME = 'prevent-scroll';

let PORTAL_COUNT = 0; // 打开的浮层总数
let PAGE_SCROLLTOP = 0; // 恢复滚动条位置

export default class Portal extends Component<IProps> {
    public defaultNode: Element | null = null;
    public componentDidMount() {
        if (this.props.preventBodyScroll) {
            PORTAL_COUNT++;
            if (PORTAL_COUNT > 0) {
                this.disableBodyScroll();
            }
        }
    }

    public componentWillUnmount() {
        if (this.props.preventBodyScroll) {
            PORTAL_COUNT--;
            if (PORTAL_COUNT <= 0) {
                this.restoreBodyScroll();
            }
        }
        if (this.defaultNode) {
            $document.body.removeChild(this.defaultNode);
        }
        this.defaultNode = null;
    }

    public render() {
        let hostNode = null;
        if (!this.props.node && !this.defaultNode) {
            this.defaultNode = $document.createElement('div');
            $document.body.appendChild(this.defaultNode);
        }
        hostNode = this.defaultNode;
        if (this.props.node) {
            hostNode = this.props.node;
        }
        if (!hostNode) {
            return null;
        }
        return createPortal(this.props.children, hostNode);
    }

    private disableBodyScroll() {
        if (PORTAL_COUNT === 1) {
            PAGE_SCROLLTOP = $document.documentElement.scrollTop || $document.body.scrollTop;
        }
        const documentElement = $document.documentElement;
        if (documentElement.className.indexOf(PREVENT_SCROLL_CLASS_NAME) === -1) {
            documentElement.className += ` ${PREVENT_SCROLL_CLASS_NAME}`;
        }
    }

    private restoreBodyScroll() {
        const documentElement = $document.documentElement;
        documentElement.className = documentElement.className.replace(PREVENT_SCROLL_CLASS_NAME, '').trim();
        if (PORTAL_COUNT === 0) {
            $document.documentElement.scrollTop = PAGE_SCROLLTOP;
            $document.body.scrollTop = PAGE_SCROLLTOP;
        }
    }
}
